import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

interface OptionCardProps {
  comingSoon?: boolean;
}

const OuterDiv = styled.div`
  position: relative;
  background-color: var(--background-secondary);
  height: 100dvh;
  width: 100%;
`;

const MainDiv = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
`;

const NewProjectSection = styled.div`
  max-width: 534px;
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  ${mobile_xl(css`
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 2px;
    gap: 24px;
  `)}
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const Title = styled.p`
  margin: 0;
  ${Typography.heading_xl_semibold};
  color: var(--text-primary);
`;

const Subtitle = styled.p`
  margin: 0;
  ${Typography.body_lg};
  color: var(--text-secondary);
`;

const OptionSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
    width: calc(100vw - 40px);
    gap: 12px;
  `)}
`;

const OptionCard = styled.div<OptionCardProps>`
  background-color: transparent;
  border: 0.5px solid transparent;
  border-radius: 10px;
  padding: ${({ comingSoon }) => (comingSoon ? '20px 12px' : '20px 12px 26px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 100%;
  &.active:hover {
    cursor: pointer;
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    box-shadow: 0px 2px 5px 0px #00000008;
    .blank-project {
      background-color: var(--background-tertiary);
    }
  }
  ${mobile_xl(css`
    flex-direction: row;
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    padding: 12px;
    width: -webkit-fill-available;
    justify-content: flex-start;
  `)}
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 41px;
  border: 0.5px solid var(--border-secondary);
  border-radius: 8px;
  &.blank-project {
    border: 0.5px dashed var(--border-secondary);
  }
  &.close-Icon {
    position: absolute;
    top: 20px;
    right: 20px;
    border: unset;
    padding: 9px;
    cursor: pointer;
    :hover {
      background-color: var(--neutral-secondary);
      svg path {
        fill: var(--text-primary);
      }
    }
  }
  ${mobile_xl(css`
    padding: 9px;
    svg {
      width: 28px;
      height: 28px;
    }
    &.close-Icon {
      position: unset;
      padding: 6px;
      svg {
        width: 20px;
        height: 20px;
      }
    }
  `)}
`;

const OptionCardTitle = styled.p`
  margin: 0;
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
const OptionCardDescription = styled.p<OptionCardProps>`
  margin: 0;
  ${Typography.body_md}
  color: var(--text-secondary);
  ${({ comingSoon }) =>
    comingSoon &&
    css`
      border: 0.5px solid var(--border-primary);
      border-radius: 6px;
      ${Typography.body_sm}
      padding: 2px 4px;
    `}
`;

const DescriptionSection = styled.div<OptionCardProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
  ${({ comingSoon }) =>
    comingSoon &&
    css`
      gap: 8px;
      ${mobile_xl(css`
        width: 100%;
        align-items: flex-start;
        flex-direction: row;
        justify-content: space-between;
      `)}
    `}
`;

export {
  MainDiv,
  NewProjectSection,
  TitleSection,
  Title,
  Subtitle,
  OptionSection,
  OptionCard,
  OptionCardTitle,
  Icon,
  DescriptionSection,
  OptionCardDescription,
  OuterDiv
};
